<template>
  <FriedModal :padded="false" @close="handleClose">
    <VideoPlayer :autoplay="true" :url="video.videoUrl" />
  </FriedModal>
</template>
<script lang="ts">
import VideoPlayer from '@getaccept/lib-shared-new/src/video/player/components/VideoPlayer.vue';
import type { SigningPageVideo } from '@getaccept/lib-shared-new/src/types/signing-page-video';
import type { PropType } from 'vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {
    VideoPlayer,
  },
  props: {
    video: {
      type: Object as PropType<SigningPageVideo>,
      required: true,
    },
  },
  setup(_props, { emit }) {
    const handleClose = () => {
      emit('close');
    };

    return {
      handleClose,
    };
  },
});
</script>
